import { createFileRoute } from '@tanstack/react-router'
import { Analise } from '@/features/ia/Analise'

/** Análise da sessão com IA: transcrição, nomes, análise e revisão. Aba das páginas da sessão; a chave fica no layout. */
export const Route = createFileRoute('/_app/app/s/$id_/_sessao/analise')({
  component: function AnaliseDaSessao() {
    const { id } = Route.useParams()
    return <Analise key={id} sessionId={id} />
  },
})
